import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  text: `DescriptionText`,
  expand: `DescriptionExpand`,
  header: `DescriptionHeader`
};

export function useDescriptionStyles(isExpanded: boolean) {
  const { spacing, semanticColors } = useTheme();
  const viewportHeight = window?.visualViewport?.height ?? 900;

  // 669 is the sizes of all other boxes and margins combined
  // may have to be reevaluated if layout changes somehow
  const maxExpandedHeight = Math.min(viewportHeight - 669, 450);

  const descriptionStyles = useMemo(
    () => mergeStyleSets({
      header: [
        classNames.header,
        {
          marginBottom: spacing.m,
          fontWeight: 600,
          fontSize: `1.1em`
        }
      ],
      text: [
        classNames.text,
        {
          maxHeight: isExpanded ? maxExpandedHeight : 80,
          overflowY: `auto`,
          "& > p": {
            margin: 0,
            paddingBottom: 2
          }
        }
      ],
      expand: [
        classNames.expand,
        {
          background: `transparent`,
          border: 0,
          height: 16,
          width: 16,
          minWidth: 16,
          color: semanticColors.buttonTextDisabled,
          selectors: {
            ":hover": {
              background: `transparent`
            },
            ":focus": {
              background: `transparent`
            },
            ":active": {
              background: `transparent`
            }
          }
        }
      ]
    }),
    [spacing, semanticColors, isExpanded, maxExpandedHeight]
  );

  const cardStyles = useMemo(
    () => mergeStyleSets({
      root: {
        margin: spacing.s2,
        padding: spacing.m
      }
    }),
    [spacing]
  );

  return { descriptionStyles, cardStyles };
}
